<template>
  <div class="vs-accordion">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VsAccordion',
};
</script>

<style lang="scss" scoped>
@import '@/styles/accordion/accordion';
@import '@/styles/core/types/types';
@import '@/styles/accessibility';
</style>
